module.exports = __webpack_public_path__ + "img/btn-foldingmat@2x.ffa63bc9.png";